const processAttributeFilterValues = ({
    values,
    searchTerm,
    getCount,
    filterExceptions = [],
}: {
    values: { value: string; label: string }[];
    searchTerm: string;
    getCount: (value: string) => number;
    filterExceptions?: string[];
}): [{ value: string; valueLabel: string }[], number] => {
    const filterExceptionsSet = new Set(filterExceptions);
    let processedValues = values;

    processedValues = processedValues.filter(
        value =>
            filterExceptionsSet.has(value.value) || getCount(value.value) > 0
    );

    const valuesCount = processedValues.length;

    if (searchTerm) {
        processedValues = processedValues.filter(
            value =>
                value.label !== '' &&
                value.label.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }

    return [
        processedValues.map(value => {
            return {
                value: value.value.replace(/\n/g, ' '),
                valueLabel: value.label,
            };
        }),
        valuesCount,
    ];
};

export default processAttributeFilterValues;
